module.exports = __webpack_public_path__ + "static/img/bg24.8b550b9a.png";